import * as React from "react";
import { observer } from "mobx-react-lite";
import { Mk8sDraftMobx } from "../../../../../mst/stores/mk8s.draft";
import { ProviderAutoscaler } from "../../../advanced/providerAutoscaler";
import { ProviderNetworking } from "../../../advanced/providerNetworking";
import { ProviderPreInstallScript } from "../../../advanced/providerPreInstallScript";
import { NGInput } from "../../../../../newcomponents/input/input";
import { NGInputListMst } from "../../../../../newcomponents/inputList/inputListMst";
import { mk8sDryRun } from "../../../../../mobxStores/dryRun/mk8s";
import { getDryRunErrorText } from "../../../getDryRunErrorText";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const Mk8sCreateProviderGCPAdvancedRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const g = mk8sDraft.provider_gcp!;

  const labelsDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.gcp.labels`,
    paths: g.labels.items.map((i) => `spec.provider.gcp.labels.${i.firstValue}`),
  });

  const tagsDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.gcp.tags`,
    paths: g.tags.items.map((i) => `spec.provider.gcp.tags.${i.firstValue}`),
  });

  const metadataDryRun = getDryRunErrorText({
    dryRunResponse: mk8sDryRun.response,
    path: `spec.provider.gcp.metadata`,
    paths: g.metadata.items.map((i) => `spec.provider.gcp.metadata.${i.firstValue}`),
  });

  return (
    //
    <>
      <div>
        <NGInputListMst
          data={g.labels}
          className="mb-8"
          label="Labels"
          firstLabel="Key"
          firstInput={(i) => {
            let invalid = false;
            if (!i.firstValue) {
              invalid = true;
            }
            if (i.firstValue && labelsDryRun.message.includes(`.${i.firstValue}`)) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.firstValue}
                onChange={(e) => i.setFirstValue(e.target.value)}
              />
            );
          }}
          secondLabel="Value"
          secondInput={(i) => {
            let invalid = false;
            if (i.secondValue && labelsDryRun.message.includes(`.${i.secondValue}`)) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.secondValue}
                onChange={(e) => i.setSecondValue(e.target.value)}
              />
            );
          }}
          invalid={labelsDryRun.severity === "error"}
          error={labelsDryRun.severity === "error" ? labelsDryRun.message : ""}
          warning={labelsDryRun.severity === "error" ? "" : labelsDryRun.message}
        />
        <NGInputListMst
          data={g.tags}
          className="mb-8"
          label="Tags"
          firstInput={(i) => {
            let invalid = false;
            if (!i.firstValue) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.firstValue}
                onChange={(e) => i.setFirstValue(e.target.value)}
              />
            );
          }}
          invalid={tagsDryRun.severity === "error"}
          error={tagsDryRun.severity === "error" ? tagsDryRun.message : ""}
          warning={tagsDryRun.severity === "error" ? "" : tagsDryRun.message}
        />
        <NGInputListMst
          data={g.metadata}
          className="mb-8"
          label="Metadata"
          firstLabel="Key"
          firstInput={(i) => {
            let invalid = false;
            if (!i.firstValue) {
              invalid = true;
            }
            if (i.firstValue && metadataDryRun.message.includes(`.${i.firstValue}`)) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.firstValue}
                onChange={(e) => i.setFirstValue(e.target.value)}
              />
            );
          }}
          secondLabel="Value"
          secondInput={(i) => {
            let invalid = false;
            if (i.secondValue && metadataDryRun.message.includes(`.${i.secondValue}`)) {
              invalid = true;
            }

            return (
              <NGInput
                required
                invalid={invalid}
                value={i.secondValue}
                onChange={(e) => i.setSecondValue(e.target.value)}
              />
            );
          }}
          invalid={metadataDryRun.severity === "error"}
          error={metadataDryRun.severity === "error" ? metadataDryRun.message : ""}
          warning={metadataDryRun.severity === "error" ? "" : metadataDryRun.message}
        />
        <div className="mb-4">
          <ProviderPreInstallScript provider="gcp" preInstallScript={g.preInstallScript} />
        </div>
        <div className="mb-4">
          <ProviderNetworking clusterDraft={mk8sDraft} networking={g.networking} />
        </div>
        <div>
          <ProviderAutoscaler provider="gcp" autoscaler={g.autoscaler} />
        </div>
      </div>
    </>
  );
};

export const Mk8sCreateProviderGCPAdvanced = observer(Mk8sCreateProviderGCPAdvancedRaw);
